import { render, staticRenderFns } from "./PhysicianViewPhysicianCrmRecordCard.vue?vue&type=template&id=48fd37e6&"
import script from "./PhysicianViewPhysicianCrmRecordCard.vue?vue&type=script&lang=js&"
export * from "./PhysicianViewPhysicianCrmRecordCard.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianViewPhysicianCrmRecordCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports